import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import '../styles/Product.scss';

export default function Accessories() {
  const [accessories, setAccessories] = useState([]);

  useEffect(() => {
    async function fetchData() {
      try {
        const res = await fetch(
          'https://sheets.googleapis.com/v4/spreadsheets/1usVfJ-1O_wRD5fcLxVQVfskcSQ-L6hmDp2kvFckvGO8/values/Лист1!A:F?key=AIzaSyAbLqcy6h2MPUSuWJh93fUax3NIAUPtgv8'
        );
        const data = await res.json();

        const rows = data.values;
        if (!rows || rows.length < 2) return;

        const headers = rows[0];
        const items = rows.slice(1).map((row) => {
          const obj = {};
          headers.forEach((h, i) => (obj[h.trim().toLowerCase()] = row[i] || ''));
          return obj;
        });

        // фильтруем по категории "accessories"
        const accessoryItems = items.filter(
          (item) => item.category?.trim().toLowerCase() === 'accessories'
        );

        setAccessories(accessoryItems);
      } catch (err) {
        console.error('Ошибка при загрузке данных:', err);
      }
    }

    fetchData();
  }, []);

  return (
    <div className="products">
      <h1>Аксессуары</h1>
      <div className="products__list">
        {accessories.length > 0 ? (
          accessories.map((accessory) => (
            <div key={accessory.id} className="products__card">
              <img src={accessory.image} alt={accessory.name} />
              <h2>{accessory.name}</h2>
              <p className="specs">{accessory.description}</p>
              <p className="price">{accessory.price}</p>
              <Link to={`/components/accessories/${accessory.id}`} className="btn">
                Подробнее
              </Link>
            </div>
          ))
        ) : (
          <p>Загрузка...</p>
        )}
      </div>
    </div>
  );
}
